import "./MyFirstRealVibe.scss";

import { VibeMessage } from "../components";
import PostWrapper from "../PostWrapper";
import { PostCategory } from "../postCategories";

function MyFirstVibeRefactorScreen() {
  return (
    <PostWrapper
      category={PostCategory.VibeCoding}
      subTitle="Is there a cool name for this yet? Vibefactoring 🤔... 👎"
      title="My first (vibe) refactor"
    >
      <p>
        I knew from the beginning of this iteration of my blog that I would end
        up refactoring things. I just didn't want to slow down my initial goals,
        so I accepted the tech debt.
      </p>

      <p>
        What I didn't know was that I would be using Codex when it came time to
        refactor, and if anything I think it makes that initial decision even
        better. It's one I would suggest making for any new project.
      </p>

      <h3>What? Any new project?!?! Knowingly take on tech debt day one?!</h3>

      <p>Yes.</p>

      <p>Or, better stated, Hell yeah!</p>

      <p>
        I think any new project would be better served by loosely setting up the
        structure and general patterns that line up with the project's goals,
        but then implementing the initial code in a totally quick and dirty way
        that doesn't consider any ways to make things reusable, cleaner,
        single-purpose, etc.
      </p>

      <p>
        Then, when you get enough code in place that the structure and patterns
        are clear, (and you can see if your original structure and patterns make
        sense), you can refactor rather easily via the "plan" pattern and
        focused vibe sessions.
      </p>

      <p>
        The big part here is that you are not asking the agent to just look at a
        bunch of random code and make its own decisions, but instead giving it
        clear structure/patterns to work within (even if they are repetitive or
        otherwise imperfect). And you can make informed requests based on the
        tech debt tradeoffs that you purposefully made in the beginning.
      </p>

      <p>
        This was my first re-vibification (nope... still not a good term), but I
        already know there are a couple more I'm about to kick off 🥳
      </p>

      <p>Vibetuning? Vibe Tuning... 🤷</p>

      <h3>Everything written below was generated by OpenAI Codex</h3>

      <p>
        This thread started as a small unused-code cleanup, then became a
        planning pass for reducing repeated registration work across posts,
        tools, recipes, routes, and tests. The useful part was how quickly the
        first cleanup exposed the next layer: not just dead files, but repeated
        maintenance steps that could be made harder to forget.
      </p>

      <div className="vibe-thread" aria-label="Conversation highlights">
        <VibeMessage from="Ryan">
          Search for any unused code and remove it
        </VibeMessage>
        <VibeMessage from="Codex">
          I used a stricter TypeScript pass and a file graph to separate real
          dead code from files used indirectly by the app tooling.
        </VibeMessage>

        <VibeMessage from="Codex">
          I found one empty, unimported stylesheet and stray `.DS_Store` files,
          removed the stylesheet, and verified the app with tests and build.
        </VibeMessage>

        <VibeMessage from="Ryan">
          Plan: Determine what in this codebase could be made more DRYer or
          otherwise cleaner, creating a plan of action for each such case
        </VibeMessage>
        <VibeMessage from="Codex">
          I inspected the repeated patterns and found the highest-value cleanup
          was content registration: paths, route entries, screen exports, list
          tiles, and latest-post metadata were being maintained in multiple
          places.
        </VibeMessage>

        <VibeMessage from="Codex">
          The plan was to create registries for posts, useful tools, and
          recipes; generate routes from those registries; share category-list
          behavior and preview tiles; consolidate post/tool wrapper structure;
          and update the recipe generator.
        </VibeMessage>

        <VibeMessage from="Ryan">
          PLEASE IMPLEMENT THIS PLAN:
          <br /># DRY/Cleaner Codebase Plan
          <br />
          <br />
          ## Summary
          <br />- Focus cleanup on repeated content registration and nearly
          identical category/list UI.
          <br />- Preserve all public URLs, current route behavior, CRA setup,
          SCSS structure, and package dependencies.
          <br />- Treat the existing
          `src/screens/code/useful-tools-and-code/UsefulToolWrapper.scss`
          deletion as already pending and unrelated to this plan.
          <br />
          <br />
          ## Key Changes
          <br />- Create single-source registries for posts, useful tools, and
          recipes.
          <br />
          &nbsp;&nbsp;- Move post preview metadata out of `PostsHome.tsx` into a
          typed posts registry that includes `path`, `title`, `teaser`,
          `category`, and `Screen`.
          <br />
          &nbsp;&nbsp;- Move useful-tool preview metadata similarly.
          <br />
          &nbsp;&nbsp;- Expand the recipe catalog to include each recipe
          `Screen` alongside `path`, `title`, and `tags`.
          <br />
          &nbsp;&nbsp;- Generate route entries by mapping these registries in
          `routes.tsx`, removing the long duplicated path/screen route blocks.
          <br />
          &nbsp;&nbsp;- Update `Home.tsx`, `PostsHome.tsx`,
          `UsefulToolsAndCodeHome.tsx`, and `FoodHome.tsx` to consume the
          registries instead of duplicating latest/list metadata.
          <br />
          <br />- Reduce duplicated category list behavior.
          <br />
          &nbsp;&nbsp;- Add a small generic helper/component for “filter by
          category, show latest item, show remaining items, render empty state.”
          <br />
          &nbsp;&nbsp;- Use it for posts and useful tools only; leave recipe
          filtering separate because it filters free-text tags/title, not
          category enums.
          <br />
          <br />- Consolidate preview tile markup.
          <br />
          &nbsp;&nbsp;- Add a generic categorized preview tile that renders
          headline, category label, and teaser.
          <br />
          &nbsp;&nbsp;- Keep `PostPreviewTile` and `UsefulToolPreviewTile` as
          thin adapters so existing call sites and styling concepts remain
          clear.
          <br />
          <br />- Consolidate post/tool page wrapper structure.
          <br />
          &nbsp;&nbsp;- Add a shared `CodeContentWrapper` for back link, title,
          optional subtitle, category label, and children.
          <br />
          &nbsp;&nbsp;- Keep `PostWrapper` and `UsefulToolWrapper` as adapters;
          `PostWrapper` continues to inject its ad/sidebar layout.
          <br />
          <br />- Clean testing boilerplate.
          <br />
          &nbsp;&nbsp;- Add a test helper that renders with `MemoryRouter`,
          `ThemeProvider`, and `CookModeProvider`.
          <br />
          &nbsp;&nbsp;- Update existing tests to use it where behavior stays
          identical.
          <br />
          <br />- Update recipe generator workflow.
          <br />
          &nbsp;&nbsp;- Update `scripts/add-recipe.js` so new recipes edit the
          new recipe registry instead of separately editing route paths,
          `routes.tsx`, `screens/index.ts`, and `recipes.ts`.
          <br />
          &nbsp;&nbsp;- Keep insertion markers where useful, but reduce the
          number of files a new recipe must touch.
          <br />
          <br />
          ## Test Plan
          <br />- Run `npm test -- --watchAll=false`.
          <br />- Run `npm run build`.
          <br />- Manually verify the generated route list still includes:
          <br />
          &nbsp;&nbsp;- home, about, privacy, terms
          <br />
          &nbsp;&nbsp;- code home, posts home, useful tools home
          <br />
          &nbsp;&nbsp;- all post routes
          <br />
          &nbsp;&nbsp;- all useful-tool routes
          <br />
          &nbsp;&nbsp;- all recipe routes
          <br />
          &nbsp;&nbsp;- catch-all route to home
          <br />- Add or update focused tests for:
          <br />
          &nbsp;&nbsp;- latest post on home comes from the post registry
          <br />
          &nbsp;&nbsp;- posts/useful-tools category filtering still shows latest
          plus remaining items correctly
          <br />
          &nbsp;&nbsp;- recipe filtering still matches title and tags
          <br />
          &nbsp;&nbsp;- footer cook mode still appears on recipe paths and not
          on `/food`
          <br />
          <br />
          ## Assumptions
          <br />- No new production dependencies.
          <br />- Public path constants can remain exported from
          `routes/paths.ts` for compatibility, but generated route entries
          should no longer require manual route blocks.
          <br />- Recipe page JSX content should not be converted wholesale to
          data-only structures; that would be a broad content rewrite with low
          payoff.
          <br />- The highest-value cleanup is reducing future content-addition
          touch points, not making every file maximally abstract.
        </VibeMessage>
        <VibeMessage from="Codex">
          I implemented the registry refactor in stages: category metadata,
          posts/tools/recipes registries, generated routes, shared
          categorized-list behavior, shared preview tile structure, wrapper
          consolidation, tests, and the recipe generator update.
        </VibeMessage>

        <VibeMessage from="Codex">
          The app ended with static top-level routes still explicit, content
          routes generated from registries, home and list pages reading from the
          registries, and the recipe generator no longer touching route or
          screen barrel files.
        </VibeMessage>

        <VibeMessage from="Ryan">
          add a test for `useCategorizedItems`
        </VibeMessage>
        <VibeMessage from="Codex">
          I added focused coverage for no selected category, selected category
          filtering, and selected category with no matches, then ran the
          targeted test and the full non-watch suite.
        </VibeMessage>
      </div>

      <p>
        The thread moved from cleanup to architecture without becoming a broad
        rewrite. The important bit was keeping the refactor pointed at the
        places future content changes had to remember: one registry entry
        instead of several separate edits.
      </p>

      <p className="vibe-handshake" aria-label="mind blown">
        🤯
      </p>
    </PostWrapper>
  );
}

export default MyFirstVibeRefactorScreen;
